// =============================================================================
// eodDropSet.js — THE list of shops whose End of Day report no longer goes to
// Google. One file, one edit, two readers (Lane CD, 14 Sep 2026).
//
// WHY IT IS ITS OWN FILE. Two completely different things need to agree about
// which shops have been switched over:
//   * the TILL (src/lib/eodWriteDrop.js, in the browser bundle) — decides whether
//     tonight's submission goes to Apps Script or straight into Supabase;
//   * the NIGHTLY JOB (tools/lane_b_forecast_import.mjs --only sync-eod, in Node)
//     — decides which shops' days it has to copy out of `daily_reports` into the
//     forecaster's input twin, because for those shops there is no longer a
//     Google row for the importer to read.
// If those two lists ever disagree, a shop stops writing to Google AND nothing
// feeds the forecaster for it — the forecast quietly goes blind on that shop.
// Lane BE kept two lists in step by hand (STOCK_WRITE_DROP_HOSTS +
// STOCK_WRITE_DROP_SITES) and its own runbook has to say "add the host to BOTH".
// This file exists so End of Day never has that problem: one edit, both readers.
//
// IT HAS NO IMPORTS ON PURPOSE. The Node-side tool loads this file directly, so
// it must not drag in the Supabase browser client (or anything else).
//
// SHIPS EMPTY. Nothing is switched over. A go-live is a reviewed one-line add
// here — one shop at a time, and only after the gate in
// RUNBOOK_EOD_WRITE_DROP.md is green for that shop.
// =============================================================================

// The kiosk hostnames whose End of Day submission SKIPS Apps Script.
// arndale is CLOSED (16 Aug 2026) and must never be listed. The kitchen has no
// End of Day screen at all, so mcr-kitchen.eatrolled.com is never listed either.
export const EOD_WRITE_DROP_HOSTS = new Set([
  /* empty until go-live — a reviewed one-line add, one FOH shop at a time:
     "trafford.eatrolled.com", "meadowhall.eatrolled.com" */
]);

// Which shop each droppable hostname is. Kept here rather than derived from the
// hostname, because 'trafford.eatrolled.com' is the shop whose key is 'tc' — a
// guess would be wrong for exactly the shop most likely to go first.
const HOST_TO_SITE = {
  "trafford.eatrolled.com": "tc",
  "meadowhall.eatrolled.com": "meadowhall",
};

/** The shop KEY for a droppable hostname, or null if it is not one we know. */
export function siteKeyForDropHost(host) {
  return HOST_TO_SITE[String(host || "").toLowerCase()] || null;
}

/**
 * The same list, as shop KEYS — what the nightly sync walks. Derived from
 * EOD_WRITE_DROP_HOSTS so the two can never drift: adding the host above is the
 * whole change. An unmapped hostname is dropped from this list AND named, so a
 * typo shows up as a loud gap rather than a silently un-synced shop.
 */
export function eodDropSiteKeys() {
  const keys = [];
  const unknown = [];
  for (const host of EOD_WRITE_DROP_HOSTS) {
    const key = siteKeyForDropHost(host);
    if (key) { if (!keys.includes(key)) keys.push(key); }
    else unknown.push(host);
  }
  return { keys, unknown };
}
